module.exports = __webpack_public_path__ + "assets/img/terminalPic11_app.6cc86bee.png";